
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/pricing",
      function () {
        return require("private-next-pages/dashboard/pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/pricing"])
      });
    }
  